import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';
import { SCOPE as listSCOPE } from '../list/types';

const selector = state => get(state, SCOPE);
const listSelector = state => get(state, listSCOPE);

export const compareDashboardIdSelector = (state, id) => {
  const compareDashboardsStore = get(state, SCOPE);
  const dashboardsData = get(compareDashboardsStore, 'tabsData');
  return get(dashboardsData, id);
};

export default selector;

export const tabsSelector = createSelector(
  selector,
  listSelector,
  (tabsStore, listStore) => {
    const { tabsOrder, tabsData } = tabsStore;
    const list = get(listStore, 'response') || [];

    const filteredList = list.filter(item => tabsOrder.includes(item.id));

    const listData = filteredList.reduce((agg, item) => {
      const newAgg = { ...agg };
      const newItem = { ...item };
      if (!item.dashboardTypeId) {
        newItem.dashboardTypeId = newItem.dashboardType && newItem.dashboardType.id;
      }
      newAgg[item.id] = newItem;
      return newAgg;
    }, {});

    const tabs = tabsOrder.map((item) => {
      if (listData[item]) {
        return listData[item];
      }
      if (tabsData[item]) {
        return tabsData[item];
      }
      return null;
    }).filter(item => !!item);

    filteredList.sort((a, b) => tabsOrder.indexOf(a.id) - tabsOrder.indexOf(b.id));

    const defaultDashboards = [{
      id: 'trends',
      name: 'Trends',
      isSaved: true,
      fixed: true,
    }];

    return [...defaultDashboards, ...tabs];
  },
);

export const compareTabsSelector = createSelector(
  tabsSelector,
  tabs => tabs.slice(1, tabs.length),
);
